export const colorHexValues = {
  Black: '#000000',
  Silver: '#e0e0e0',
  White: '#ffffff',
  Gray: '#989898',
  Red: '#dc4444',
  Blue: '#3f72b0',
  Gold: '#c29050',
  Orange: '#da7a38',
  Green: '#748959',
  Brown: '#76523c',
  Beige: '#cbb0a1'
};
